import React from 'react';
import Lottie from 'react-lottie-player';

import * as animacao from './erro.json';

const Erro = (): React.ReactElement =>
{
    return (
        <Lottie
            play
            loop={ false }
            animationData={ animacao }
            style={{ width: '500px' }}
            renderer={ 'canvas' as 'svg' }
        />
    );
}

export default Erro;
